declare const THREE: any;

export class WhiteSheet extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));

  public static readonly Name = 'WhiteSheet';

  constructor() {
    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(WhiteSheet.rotationTransform);
    const material = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      color: 0xffffff
    });
    super(geometry, material);
    this.name = WhiteSheet.Name;
    this.scale.set(15000, 1, 15000);
  }

  raycast() {
    return [];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/WhiteSheet.ts